<div class="performance-eval-container">
  @if (
    !isStudent() ||
    assignment?.evaluatorVideoUrl ||
    assignment?.feedback ||
    hasTotalScore
    ) {
    <div
      class="feedback-video-rubric-container"
      >
      <!-- Feedback Video Label -->
      <div class="feedback-video-label-container">
        <span class="data-label font-size-14px"
          >Teacher Feedback Video</span
          >
        </div>
        <div class="feedback-video-content-container">
          @if (!assignment?.evaluatorVideoUrl && isStudent()) {
            <no-video-found
            ></no-video-found>
          }
          @if (assignment?.evaluatorVideoUrl || !isStudent()) {
            <video
              class="media-player"
              #video
              playsinline
              autoplay
              [src]="assignment?.evaluatorVideoUrl"
              [ngStyle]="{ background: '#000' }"
            ></video>
          }
          @if (showOverlay) {
            <div id="overlay">
              <div class="timer">{{ countdownTimer }}</div>
            </div>
          }
          @if (errorMsg) {
            <div class="errorMsg">
              <p>{{ errorMsg }}</p>
            </div>
          }
          @if (!isStudent() && !isIosMobile) {
            <div>
              @if (!isRecording) {
                <button
                  mat-button
                  type="button"
                  color="default"
                  [disabled]="!isSecureOrigin"
                  (click)="recordingCountdownDelay()"
                  >
                  <mat-icon>videocam</mat-icon>
                  Record
                </button>
              }
              @if (isRecording) {
                <button
                  mat-button
                  color="default"
                  type="button"
                  (click)="stopRecording()"
                  >
                  <mat-icon>videocam_off</mat-icon>
                  Stop
                </button>
              }
              <!-- This button appears to be no longer necessary
              <button
                *ngIf="!isWorldLanguageProgram"
                    [disabled]="
                        submitClicked ||
                        feedbackForm.invalid ||
                        (feedbackForm.pristine && !videoRecorded)
                    "
                mat-raised-button
                type="button"
                color="primary"
                (click)="taskComplete()"
                >
                Submit Video
              </button>-->
            </div>
          }
          @if (!isStudent() && isIosMobile) {
            <div>
              <input
                class="upload-input"
                type="file"
                ng2FileSelect
                placeholder=""
                #fileUploader
                [accept]="getMimeTypes()"
                [uploader]="uploader"
                (change)="onUploaderChange($event)"
                (onFileSelected)="fileSelected()"
                />
              <button
                id="file-select-button"
                class="file-select-button"
                mat-raised-button
                color="default"
                (click)="fileUploader.click()"
                >
                <mat-icon>folder_open</mat-icon>
                Upload or Record Feedback Video
              </button>
              @if (!isWorldLanguageProgram) {
                <button
                    [disabled]="
                        submitClicked ||
                        feedbackForm.invalid ||
                        (feedbackForm.pristine &&
                            !(showUploadedVideo || videoRecorded))
                    "
                  mat-raised-button
                  type="button"
                  color="primary"
                  (click)="taskComplete()"
                  >
                  Submit Video
                </button>
              }
            </div>
          }
        </div>
        @if (!isWorldLanguageProgram && !isStudent() && isComposite) {
          <div
            fxLayout="column"
            >
            <button
                [disabled]="
                    submitClicked || !(showUploadedVideo || videoRecorded)
                "
              mat-raised-button
              type="button"
              color="primary"
              (click)="taskComplete()"
              >
              Submit Video
            </button>
          </div>
        }
        @if (isWorldLanguageProgram) {
          <div fxLayout="column">
            <form
              novalidate
              class="feedbackForm"
              [formGroup]="feedbackForm"
              fxLayout="column"
              fxLayoutAlign="center center"
              fxFlex="100"
              >
              <div fxLayout="column" fxLayoutAlign="center" fxFlexFill>
                @if (!isStudent()) {
                  <div class="scores-description">
                    <!-- Feedback Video Label -->
                    <div class="feedback-rubric-label-container">
                      <span class="data-label font-size-14px"
                        >Rubric Scores</span
                        >
                      </div>
                      <div class="scores-text">
                        For recommendations on how to score Performance
                        activities, please refer to our
                        <a
                          target="_blank"
                          href="https://quechevere1.myemcp.com/rubric"
                          >Oral Proficiency Rubric</a
                          >.
                        </div>
                      </div>
                    }
                    <div class="slider-container" fxLayout="row wrap">
                      @for (slider of sliders; track slider) {
                        <div>
                          @if (!slider.isSlider) {
                            <div
                              class="perform-eval-slider"
                              >
                              <div class="perform-eval-slider-title">
                                {{ slider.key }}
                                @if (slider.isSlider && isStudent()) {
                                  <span
                                    class="eval-slider-score-text"
                                    >
                                    ({{ slider.val }} /
                                    {{ slider.maxVal }})</span
                                    >
                                  }
                                </div>
                                <div class="perform-eval-slider-gauge">
                                  <!-- TODO: The 'tickInterval' property no longer exists -->
                                  @if (slider.isSlider && isStudent()) {
                                    <mat-slider
                                      thumbLabel
                                      style="width: 100%"
                                      [max]="slider.maxVal"
                                      min="0"
                                      step="1"
                                      [disabled]="isStudent()"
                                      [formControlName]="slider.key"
                                      ><input matSliderThumb /><input matSliderThumb />
                                    </mat-slider>
                                  }
                                  @if (!slider.isSlider) {
                                    <mat-radio-group
                                      class="radio-button-container"
                                      aria-label="Select an option"
                                      [formControlName]="slider.key"
                                      [disabled]="isStudent()"
                                      >
                                      <!-- Novice -->
                                      <div class="radio-button-level-wrapper">
                                        <div
                                          class="radio-button-level-title"
                                          >
                                          Novice
                                        </div>
                                        <div
                                          class="radio-button-level-scores"
                                          >
                                          <div
                                            class="radio-button-wrapper"
                                            >
                                            <div
                                              class="radio-button-circle"
                                              >
                                              <mat-radio-button
                                                value="1"
                                              ></mat-radio-button>
                                            </div>
                                            <div
                                              class="radio-button-label"
                                              >
                                              low
                                            </div>
                                          </div>
                                          <div
                                            class="radio-button-wrapper"
                                            >
                                            <div
                                              class="radio-button-circle"
                                              >
                                              <mat-radio-button
                                                value="2"
                                              ></mat-radio-button>
                                            </div>
                                            <div
                                              class="radio-button-label"
                                              >
                                              mid
                                            </div>
                                          </div>
                                          <div
                                            class="radio-button-wrapper"
                                            >
                                            <div
                                              class="radio-button-circle"
                                              >
                                              <mat-radio-button
                                                value="3"
                                              ></mat-radio-button>
                                            </div>
                                            <div
                                              class="radio-button-label"
                                              >
                                              high
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="radio-button-separator"
                                      ></div>
                                      <!-- Intermediate -->
                                      <div class="radio-button-level-wrapper">
                                        <div
                                          class="radio-button-level-title"
                                          >
                                          Intermediate
                                        </div>
                                        <div
                                          class="radio-button-level-scores"
                                          >
                                          <div
                                            class="radio-button-wrapper"
                                            >
                                            <div
                                              class="radio-button-circle"
                                              >
                                              <mat-radio-button
                                                value="4"
                                              ></mat-radio-button>
                                            </div>
                                            <div
                                              class="radio-button-label"
                                              >
                                              low
                                            </div>
                                          </div>
                                          <div
                                            class="radio-button-wrapper"
                                            >
                                            <div
                                              class="radio-button-circle"
                                              >
                                              <mat-radio-button
                                                value="5"
                                              ></mat-radio-button>
                                            </div>
                                            <div
                                              class="radio-button-label"
                                              >
                                              mid
                                            </div>
                                          </div>
                                          <div
                                            class="radio-button-wrapper"
                                            >
                                            <div
                                              class="radio-button-circle"
                                              >
                                              <mat-radio-button
                                                value="6"
                                              ></mat-radio-button>
                                            </div>
                                            <div
                                              class="radio-button-label"
                                              >
                                              high
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="radio-button-separator"
                                      ></div>
                                      <!-- Advanced -->
                                      <div class="radio-button-level-wrapper">
                                        <div
                                          class="radio-button-level-title"
                                          >
                                          Advanced
                                        </div>
                                        <div
                                          class="radio-button-level-scores"
                                          >
                                          <div
                                            class="radio-button-wrapper"
                                            >
                                            <div
                                              class="radio-button-circle"
                                              >
                                              <mat-radio-button
                                                value="7"
                                              ></mat-radio-button>
                                            </div>
                                            <div
                                              class="radio-button-label"
                                              >
                                              low
                                            </div>
                                          </div>
                                          <div
                                            class="radio-button-wrapper"
                                            >
                                            <div
                                              class="radio-button-circle"
                                              >
                                              <mat-radio-button
                                                value="8"
                                              ></mat-radio-button>
                                            </div>
                                            <div
                                              class="radio-button-label"
                                              >
                                              mid
                                            </div>
                                          </div>
                                          <div
                                            class="radio-button-wrapper"
                                            >
                                            <div
                                              class="radio-button-circle"
                                              >
                                              <mat-radio-button
                                                value="9"
                                              ></mat-radio-button>
                                            </div>
                                            <div
                                              class="radio-button-label"
                                              >
                                              high
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </mat-radio-group>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    @if (!isStudent() && isComposite) {
                      <button
                    [disabled]="
                        submitClicked ||
                        feedbackForm.invalid ||
                        (feedbackForm.pristine &&
                            !(showUploadedVideo || videoRecorded))
                    "
                        mat-raised-button
                        type="button"
                        color="primary"
                        (click)="taskComplete()"
                        >
                        Submit Video and/or Rubric
                      </button>
                    }
                  </form>
                </div>
              }
            </div>
          }
          <div fxFlexFill>
            @if (submitClicked) {
              <mat-progress-bar
                mode="determinate"
                value="{{ (uploader?.queue)[0]?.progress }}"
              ></mat-progress-bar>
            }
          </div>
        </div>
